import { Notification, useForm } from '@app/components'
import { DynamicForm, EDynamicFormField, generateDynamicFields } from '@app/modules'
import { IStore } from '@app/redux'
import { auth, Axios, errorHandler } from '@app/services'
import { useMemo, useState } from 'react'

export function ReferralsWalletForm({ user }: { user: IStore['user'] }) {
  const [form] = useForm()
  const [submitting, setSubmitting] = useState(false)

  const initialValues = useMemo(() => {
    return {
      address: user.referralPayoutAddress,
    }
  }, [user.referralPayoutAddress])

  const onSubmit = async () => {
    setSubmitting(true)
    let address
    try {
      const data = await form.validateFields()
      address = data.address
    } catch (error) {
      return
    }

    try {
      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }

      const gloryCheckResponse = await Axios.post(
        '/api/coast/glory-check',
        { address: address },
        {
          headers,
        },
      )

      if (gloryCheckResponse.data.verified) {
        Notification({
          type: 'success',
          message: 'Glory Referral Queued',
        })
      }

      Notification({
        type: 'success',
        message: 'Wallet address saved',
      })
    } catch (error) {
      errorHandler.report(error)
      Notification({
        type: 'error',
        message: 'Failed to save wallet address',
      })
    }

    setSubmitting(false)
  }

  return (
    <DynamicForm
      form={form}
      fields={generateDynamicFields(
        [
          {
            inline: [
              {
                name: 'address',
                placeholder: 'Enter wallet address',
                rules: [
                  {
                    message: 'Wallet address is required',
                    required: true,
                  },
                ],
                type: EDynamicFormField.INPUT,
              },
              {
                name: 'button',
                title: 'Save',
                type: EDynamicFormField.PRIMARY_BUTTON,
              },
            ],
          },
        ],
        [
          {
            name: 'button',
            loading: submitting,
          },
        ],
      )}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  )
}
